import { gql } from "@apollo/client";

export const ON_COMPANY_REMOTE_SYNC_LOG_SUBSCRIPTION = gql`
  subscription OnCompanyRemoteSyncLog($companyId: Int!) {
    remote_sync_log(where: { company_id: { _eq: $companyId } }, limit: 1) {
      id
      status
      log
      sync_results
      started_at
      completed_at
      updated_at
    }
  }
`;

export interface CompanyRemoteSyncLogSubscription {
  id: number;
  status: string;
  log: string;
  sync_results: {
    memberportal?: { request: unknown; response: unknown };
    partnernetwork?: { request: unknown; response: unknown };
    scoreboard?: { request: unknown; response: unknown };
    craft?: { request: unknown; response: unknown };
  } | null;
  started_at: string | null;
  completed_at: string | null;
  updated_at: string;
}

export interface CompanyRemoteSyncLogSubscriptionData {
  remote_sync_log: CompanyRemoteSyncLogSubscription[];
}
